import { organizationVehicleSettingsState } from '../initialState';

function withStatus(state, loading, error) {
  return Object.assign({}, state.organizationVehicleSettingsStatus, { loading, error });
}

function withRowStatus(state, vehicleId, saving, error) {
  const rowStatus = Object.assign({}, state.organizationVehicleSettingsRowStatus);
  rowStatus[vehicleId] = { saving, error };
  return rowStatus;
}

export default function (state = organizationVehicleSettingsState, action) {
  switch (action.type) {
    case 'FETCH_ORGANIZATION_VEHICLE_SETTINGS_REQUEST': {
      return {
        ...state,
        organizationVehicleSettingsRowStatus: {},
        organizationVehicleSettingsStatus: withStatus(state, true, null),
      };
    }
    case 'FETCH_ORGANIZATION_VEHICLE_SETTINGS_SUCCESS': {
      return {
        ...state,
        organizationVehicleSettings: action.payload,
        organizationVehicleSettingsStatus: withStatus(state, false, null),
      };
    }
    case 'FETCH_ORGANIZATION_VEHICLE_SETTINGS_FAIL': {
      return {
        ...state,
        organizationVehicleSettings: [],
        organizationVehicleSettingsStatus: withStatus(state, false, action.payload),
      };
    }
    case 'FETCH_ORGANIZATION_VEHICLE_SETTINGS_CHOICES_SUCCESS': {
      return { ...state, organizationVehicleSettingsChoices: action.payload };
    }
    case 'FETCH_ORGANIZATION_VEHICLE_SETTINGS_CHOICES_FAIL': {
      return { ...state, organizationVehicleSettingsChoices: null };
    }
    case 'UPDATE_ORGANIZATION_VEHICLE_SETTINGS_REQUEST': {
      return {
        ...state,
        organizationVehicleSettingsRowStatus: withRowStatus(state, action.additionalData.vehicleId, true, null),
      };
    }
    case 'UPDATE_ORGANIZATION_VEHICLE_SETTINGS_SUCCESS': {
      const updated = action.payload;
      return {
        ...state,
        organizationVehicleSettings: state.organizationVehicleSettings.map(
          (row) => (row.vehicle_id === updated.vehicle_id ? updated : row),
        ),
        organizationVehicleSettingsRowStatus: withRowStatus(state, updated.vehicle_id, false, null),
      };
    }
    case 'UPDATE_ORGANIZATION_VEHICLE_SETTINGS_FAIL': {
      return {
        ...state,
        organizationVehicleSettingsRowStatus: withRowStatus(
          state, action.additionalData.vehicleId, false, action.payload || true,
        ),
      };
    }
    default:
      break;
  }
  return state;
}
